import { call, select, take } from 'redux-saga/effects'

import { types as trackingActionTypes } from '../../actions/tracking'
import { selectCampaignName, selectCampaignRetailerId } from '../../selectors/campaign'
import { trackSFPost } from './providers'

function* watchAppbeforeUnload() {
  yield take(trackingActionTypes.APP_UNLOAD)

  const campaignName = yield select(selectCampaignName)
  const retailerId = yield select(selectCampaignRetailerId)
  const at = {
    s2s_ea: 'end',
    s2s_el: campaignName,
    s2s_ev: retailerId,
  }
  const et = 'Slide2Store/End'

  yield call(trackSFPost, et, at, true)
}

export default watchAppbeforeUnload
